import { effect, inject } from '@angular/core';
import type { CanActivateFn, GuardResult } from '@angular/router';
import { Router } from '@angular/router';

import { ProductAdminContext } from '#/app/shared/services/product-admin.context';

/**
 * Guard to check if the user has product roles.
 * @returns Resolves to true if the user has product roles, otherwise redirects the user to `/admin/no-access`
 */
export const productRoleGuard: CanActivateFn = () => {
  const productAdminContext = inject(ProductAdminContext);
  const router = inject(Router);
  return new Promise<GuardResult>((resolve) => {
    const effectRef = effect(
      () => {
        if (productAdminContext.hasCurrentProductUserLoaded()) {
          effectRef.destroy();
          if (productAdminContext.isProductUser()) {
            resolve(true);
          } else {
            resolve(
              router.createUrlTree([`/admin/no-access`], {
                queryParams: { reason: 'unauthorized' },
              }),
            );
          }
        }
      },
      { manualCleanup: true },
    );
  });
};
